import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fa646240")

_pushScopeId("data-v-fa646240")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "所属单位", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "活跃状况", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("有检车 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "服务日期", -1)
const _hoisted_7 = { class: "flex alignC top-button-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "保险到期时间", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "是否有保险到期时间", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, " 导出 ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, " 新增车辆 ", -1)
const _hoisted_12 = { class: "c-red" }
const _hoisted_13 = {
  key: 0,
  class: "flex flexC"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "view-cirle" }, "B", -1)
const _hoisted_15 = {
  key: 1,
  class: "flex flexC"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "view-cirle" }, "C", -1)
const _hoisted_17 = { class: "flex flexC button-group" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "服务历史", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_20 = { class: "flex flexR mar-t-22" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "查找车型", -1)
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.repair_unit_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.repair_unit_id = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: "",
        filterable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.repair, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.repair_unit_name,
              value: item.repair_unit_id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.yue,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.yue = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.liveness, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.screenParameter.is_check,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.is_check = $event)),
        class: "mar-r-8",
        "true-label": "1",
        "false-label": "0",
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectChange()))
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "mar-l-16 mar-r-18",
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "车牌号码/车架号",
        "suffix-icon": "el-icon-search",
        style: {"width":"220px"},
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectChange($event)))
      }, null, 8, ["modelValue"]),
      _hoisted_6,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.screenParameter.service_time,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.service_time = $event)),
        class: "mar-r-16",
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        onChange: _ctx.serviceDateChange
      }, null, 8, ["modelValue", "onChange"])
    ]),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.screenParameter.expiration_time,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.screenParameter.expiration_time = $event)),
        class: "mar-r-16",
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        format: "MM-DD",
        "disabled-date": _ctx.disabledDate,
        onChange: _ctx.expirationTimeChange
      }, null, 8, ["modelValue", "disabled-date", "onChange"]),
      _hoisted_9,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.is_expiration_date,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenParameter.is_expiration_date = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "有",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "无",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.exportChange
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.addCarDialog
      }, {
        default: _withId(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "code",
            label: "车牌号码",
            "min-width": "66"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_12, _toDisplayString(scope.row.code), 1),
              (scope.row.is_admin_add == 1)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true),
              (scope.row.is_online_salesman == 1)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "120"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.columnChange(scope.row, 1))
                }, {
                  default: _withId(() => [
                    _hoisted_18
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.columnChange(scope.row, 3))
                }, {
                  default: _withId(() => [
                    _hoisted_19
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50, 100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "车辆信息",
      modelValue: _ctx.editCarData.dialog_show,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.editCarData.dialog_show = $event)),
      center: "",
      width: 1100
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.saveSubmit
          }, {
            default: _withId(() => [
              _hoisted_23
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.editCarData.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: _ctx.editCarData.formRef,
          model: _ctx.editCarData.form,
          rules: _ctx.editCarData.rules,
          "label-width": "140px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "VIN",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "width-200",
                          modelValue: _ctx.editCarData.form.vin,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.editCarData.form.vin = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          class: "mar-l-8",
                          onClick: _ctx.checkVinInfo
                        }, {
                          default: _withId(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "品牌车型",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          class: "mar-r-8",
                          modelValue: _ctx.editCarData.form.car_brand_id,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.editCarData.form.car_brand_id = $event)),
                          style: {"width":"108px"},
                          filterable: "",
                          placeholder: "请选择",
                          onChange: _ctx.selectCarBrandChange
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editCarData.car_brand_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.brand_name,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"]),
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.editCarData.form.car_series_id,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.editCarData.form.car_series_id = $event)),
                          placeholder: "请选择",
                          style: {"width":"132px"}
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editCarData.car_series_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.series_name,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "所属单位",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.units_id,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.editCarData.form.units_id = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editCarData.repairunit_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.repair_unit_name,
                                value: item.repair_unit_id,
                                key: item.repair_unit_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "车身颜色",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.body_color,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.editCarData.form.body_color = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "车牌号",
                      prop: "code"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.code,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.editCarData.form.code = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "车主手机",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.car_master_phone,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.editCarData.form.car_master_phone = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "车主姓名",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.master_name,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.editCarData.form.master_name = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "发动机号",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.engine_number,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.editCarData.form.engine_number = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "车主身份证",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.idcard,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.editCarData.form.idcard = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "保养里程",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.maintenance_mileage,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.editCarData.form.maintenance_mileage = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "购车时间",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.purchase_time_text,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.editCarData.form.purchase_time_text = $event)),
                          placeholder: "请选择购车时间",
                          onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.saveCarInfoChange($event, 'purchase_time')))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "接车提示",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.tips,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.editCarData.form.tips = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "下次保养",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.nm_time_text,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.editCarData.form.nm_time_text = $event)),
                          placeholder: "请选择下次保养时间",
                          onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.saveCarInfoChange($event, 'nmtime')))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "保养录入人",
                      prop: "nm_constructor_id"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.editCarData.form.nm_constructor_name || '-'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "年检到期",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.aidue_text,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.editCarData.form.aidue_text = $event)),
                          placeholder: "请选择年检到期时间",
                          onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.saveCarInfoChange($event, 'aidue')))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "年检到期录入人",
                      prop: "aidue_constructor_name"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.editCarData.form.aidue_constructor_name || '-'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商业险到期",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.ccidue_text,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.editCarData.form.ccidue_text = $event)),
                          placeholder: "请选择商业险到期时间",
                          onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.saveCarInfoChange($event, 'ccidue')))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商业险到期录入人",
                      prop: "ccidue_constructor_name"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.editCarData.form.ccidue_constructor_name || '-'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商业险公司",
                      prop: "vin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.cicompany_id,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.editCarData.form.cicompany_id = $event)),
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editCarData.insurance_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商业险保单号",
                      prop: "cipnumber"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.cipnumber,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.editCarData.form.cipnumber = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "交强险到期",
                      prop: "compulsory_insurance_due_text"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.compulsory_insurance_due_text,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.editCarData.form.compulsory_insurance_due_text = $event)),
                          placeholder: "请选择交强险到期时间",
                          onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveCarInfoChange($event, 'compulsory_insurance_due')))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "交强险到期录入人",
                      prop: "cidue_constructor_name"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.editCarData.form.cidue_constructor_name || '-'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "交强险公司",
                      prop: "jicompany_id"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.jicompany_id,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.editCarData.form.jicompany_id = $event)),
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editCarData.insurance_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "交强险保单号",
                      prop: "dipolicy_no"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editCarData.form.dipolicy_no,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.editCarData.form.dipolicy_no = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})